var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurfboardAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3691 18.0972C12.0136 19.4952 11.5088 20.826 10.8573 22H5.09144C4.46158 20.7374 3.96383 19.3075 3.61218 17.8155L8.01596 15.3706L12.3691 18.0972Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7002 16.5346C13.1404 13.9616 13.098 11.2782 12.5588 9C11.8709 6.0934 9.02147 2 8.03896 2C7.05646 2 3.99698 6.04295 3.35904 9C2.88863 11.1805 2.89118 13.7613 3.3039 16.271L8.06195 13.6294L12.7002 16.5346Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3097 20.1676C13.5416 20.8068 13.8027 21.421 14.0915 22H19.8573C21.916 18.2904 22.5093 13.0157 21.5588 9C20.8709 6.0934 18.0215 2 17.039 2C16.315 2 14.4634 4.19509 13.2838 6.5334C13.5982 7.24749 13.8564 7.96954 14.0185 8.65451C14.8461 12.1513 14.6042 16.4915 13.3097 20.1676Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfboardAlt2);
export default __webpack_public_path__ + "static/media/surfboard-alt-2.781e6cbf93d6e94c19aa18ff4b0b94cf.svg";
export { ForwardRef as ReactComponent };